import {Securities} from "../../../instruments/types/CodeAndExchange";
import {SecurityInformationRecord, SecurityInformationRecords} from "../types/SecurityInformationRecord";
import {Observable} from "rxjs";
import {SecurityInformationService} from "../service/SecurityInformationService";
import {ClientEventService} from "../../../services/client-events/ClientEventService";
import {SystemEventService} from "../../../services/system-state/SystemEventService";
import {SecurityDataStore} from "../../common/store/SecurityDataStore";

export class SecurityInformationStore extends SecurityDataStore<SecurityInformationRecord> {

    public static readonly id = "securityInformationStore";

    /** @ngInject */
    public constructor(private readonly securityInformationService: SecurityInformationService,
                       clientEventService: ClientEventService,
                       systemEventService: SystemEventService) {
        super(clientEventService, systemEventService);
    }

    protected retrieveData(securities: Securities): Observable<SecurityInformationRecords> {
        return Observable.of(securities)
                         .flatMap((s) => this.securityInformationService.list(s))
                         .catch((err) => Observable.empty());
    }
}
